import { useEffect, useState } from 'react'

let isSubscriptionChangedState = false
let listeners = []

const setIsSubscriptionChangedState = (state) => {
    isSubscriptionChangedState = state
    listeners.forEach(listener => listener(isSubscriptionChangedState))
}

const subscribe = (listener) => {
    listeners.push(listener)
    return () => {
        listeners = listeners.filter(l => l !== listener)
    }
}

// We use this to raise a flag when the subscription is changed, usful when need to clear the ads data after upgrade to avoid show the ads with the old ad spend limit
export const useIsSubscriptionChanged = () => {
    const [isSubscriptionChanged, setIsSubscriptionChanged] = useState(isSubscriptionChangedState)

    useEffect(() => {
        const unsubscribe = subscribe(setIsSubscriptionChanged)
        return () => unsubscribe()
    }, [])

    return isSubscriptionChanged
}

export const toggleIsSubscriptionChanged = (state) => setIsSubscriptionChangedState(state)